/**
 * Route for `saved-report-templates`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SavedReportTemplatesPage } from "../features/saved-report-templates/SavedReportTemplatesPage";

export const savedReportTemplatesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/saved-report-templates",
	component: SavedReportTemplatesPage,
});

export default savedReportTemplatesRoute;
